export const generateRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
};

export const generateRandomOperator = (operators) => {
  const randomNumber = Math.floor(Math.random() * ((operators.length - 1) - 0 + 1) + 0);
  return operators[randomNumber];
};

export const roundToNearestWholeNumber = (value) => {
  return Math.round(value);
}

export const totalUpNumbers = (content) => {
  if (!content || typeof content !== 'string') return 0;
  const numbers = content.match(/-?\d+(\.\d+)?/g);
  return numbers ? numbers.reduce((sum, num) => sum + Number(num), 0) : 0;
};